function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from 'components/Form/Button';
import * as actions from '../../../actions';
import messages from '../../../messages';
import SettingsForm from './SettingsForm';
import ExportData from './ExportData';
var _React_PureComponent;
class ProfileSettings extends (_React_PureComponent = React.PureComponent) {
    renderContourIdActions() {
        const className = 'btn--block m-0 text--primary text--normal';
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    "data-testid": "change-account-information",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "transparent",
                        labelMessage: messages.buttons.changeAccountInformation,
                        className: className,
                        onClick: this.props.onEdit
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    "data-testid": "change-password",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "transparent",
                        labelMessage: messages.buttons.changePassword,
                        className: className,
                        onClick: this.props.onChangePassword
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-6 pr-10",
                    children: [
                        /*#__PURE__*/ _jsx(SettingsForm, {}),
                        /*#__PURE__*/ _jsx("hr", {
                            className: "form-divider mt-7 mb-4"
                        }),
                        this.renderContourIdActions()
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6 pl-10",
                    children: /*#__PURE__*/ _jsx(ExportData, {})
                })
            ]
        });
    }
}
_define_property(ProfileSettings, "propTypes", {
    // Implicit actions
    onChangePassword: PropTypes.func,
    onEdit: PropTypes.func
});
const mapDispatchToProps = (dispatch)=>({
        onChangePassword: ()=>dispatch(actions.changeAidPassword()),
        onEdit: ()=>dispatch(actions.editAidAccount())
    });
const ConnectedProfileSettings = connect(null, mapDispatchToProps)(ProfileSettings);
export default ConnectedProfileSettings;
